const SubscriptionList = () => import("@/views/subscription/subscriptionList.vue");

const TYPE = "ADMIN";

export default {
  path: "subscription-pricing",
  meta: { label: "Subscription" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      name: "SubscriptionList",
      meta: {
        requiresAuth: true,
        type: TYPE,
      },
      component:
        SubscriptionList,
    },
  ],

}